/**
 * "Oct 14, 2026", or null for a missing value so DetailList/DataTable show a dash.
 * A date-only value ("2026-10-14") is a calendar day, not UTC midnight, so it's
 * read as local noon; otherwise it would show the day before in US time zones.
 */
export function formatDate(value) {
  if (!value) return null
  const date = /^\d{4}-\d{2}-\d{2}$/.test(value) ? new Date(`${value}T12:00:00`) : new Date(value)
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
}

/**
 * An exact moment ("2026-10-29T21:00:00Z") as the value of an
 * <input type="datetime-local">, in this person's own time ("2026-10-29T17:00"
 * in Atlanta). The input has no time zone, so without this it would show (and
 * the server would read back) UTC.
 */
export function toLocalInput(value) {
  if (!value) return ''
  const date = new Date(value)
  const pad = (n) => String(n).padStart(2, '0')
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`
}

/** The other way: what they typed, in their own time, as an exact moment for the server. */
export function fromLocalInput(value) {
  return value ? new Date(value).toISOString() : null
}

/** "18:30" → "6:30 PM". Event times are local wall-clock times, so no zone conversion. */
export function formatTime(hhmm) {
  if (!hhmm) return null
  const [h, m] = hhmm.split(':').map(Number)
  return `${((h + 11) % 12) + 1}:${String(m).padStart(2, '0')} ${h < 12 ? 'AM' : 'PM'}`
}

/** "$1,250" from 1250, or null. */
export function formatMoney(value) {
  if (value == null || value === '') return null
  const amount = Number(value)
  // Whole dollars stay whole ($760); anything with cents shows both digits ($617.50).
  const digits = Number.isInteger(amount) ? 0 : 2
  return `$${amount.toLocaleString('en-US', { minimumFractionDigits: digits, maximumFractionDigits: 2 })}`
}
